import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
// import { IConfig, NgxMaskModule } from 'ngx-mask';
// import { TreeviewModule } from 'ngx-treeview';;
// import { InputCodeReactComponent } from './code-react/code-input/input-code-react.component';
// import { InputFileDropReactComponent } from './input-file-drop-react/input-file-drop-react.component';
// import { InputFileGridReactComponent } from './input-file-grid-react/input-file-grid-react.component';
import { QuillModule } from 'ngx-quill';
import { NgxSpinnerModule } from 'ngx-spinner';
import { InputUtilsModule } from '../input-utils/input-utils.module';
import { InputAutoCompleteReactComponent } from './input-auto-complete-react/input-auto-complete-react.component';
import { InputBooleanDropDownReactComponent } from './input-boolean-dropdown-react/input-boolean-dropdown-react.component';
import { InputBooleanReactComponent } from './input-boolean-react/input-boolean-react.component';
import { InputColorReactComponent } from './input-color-react/input-color-react.component';
import { InputDateTimeReactComponent } from './input-date-react/input-datetime-react.component';
import { InputDecimalReactComponent } from './input-decimal-react/input-decimal-react.component';
import { InputDropDownReactComponent } from './input-dropdown-react/input-dropdown-react.component';
// import { InputFileReactComponent } from './input-file-react/input-file-react.component';
import { InputIntegerReactComponent } from './input-integer-react/input-integer-react.component';
import { InputItemListComponent } from './input-item-list/input-item-list.component';
import { InputKeyvalueListComponent } from './input-keyvalue-list/input-keyvalue-list.component';
import { InputListboxReactComponent } from './input-listbox-react/input-listbox-react.component';
// import { InputNodesReactComponent } from './input-nodes-react/input-nodes-react.component';
import { InputPasswordReactComponent } from './input-password-react/input-password-react.component';
import { InputPromptModalComponent } from './input-prompt-modal/input-react-prompt-modal.component';
import { InputRadioReactComponent } from './input-radio-react/input-radio-react.component';
import { InputRichTextReactComponent } from './input-rich-text-react/input-rich-text-react.component';
import { InputSelectReactComponent } from './input-select-react/input-select-react.component';
import { InputSelectableListReactComponent } from './input-selectable-list-react/input-selectable-list-react.component';
import { InputStringReactComponent } from './input-string-react/input-string-react.component';
import { InputTelReactComponent } from './input-tel-react/input-tel-react.component';
import { InputTextReactComponent } from './input-text-react/input-text-react.component';
// import { InputTreeViewCardsReactComponent } from './input-treeview-cards-react/input-treeview-cards-react.component';
// import { InputTreeViewReactComponent } from './input-treeview-react/input-treeview-react.component';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideEnvironmentNgxMask } from 'ngx-mask';
import { InputDateTimeAltReactComponent } from './input-datetime-alt/input-datetime-alt-react.component';
const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgbModule,
    InputUtilsModule,
    QuillModule.forRoot(),
    NgxSpinnerModule,
    DragDropModule,
    NgxMaskDirective,
    NgxMaskPipe
  ],
  declarations: [
    InputAutoCompleteReactComponent,
    InputBooleanReactComponent,
    InputBooleanDropDownReactComponent,
    InputColorReactComponent,
    InputDateTimeReactComponent,
    InputDecimalReactComponent,
    InputDropDownReactComponent,
    InputIntegerReactComponent,
    InputListboxReactComponent,
    InputPasswordReactComponent,
    InputSelectReactComponent,
    InputStringReactComponent,
    InputTelReactComponent,
    InputTextReactComponent,
    // InputFileReactComponent,
    // InputTreeViewReactComponent,
    // InputTreeViewCardsReactComponent,
    InputItemListComponent,
    InputKeyvalueListComponent,
    InputRichTextReactComponent,
    // InputFileDropReactComponent,
    // InputFileGridReactComponent,
    InputPromptModalComponent,
    // InputNodesReactComponent,
    InputSelectableListReactComponent,
    InputRadioReactComponent,
    InputDateTimeAltReactComponent,
  ],
  exports: [
    InputAutoCompleteReactComponent,
    InputBooleanReactComponent,
    InputBooleanDropDownReactComponent,
    InputColorReactComponent,
    InputDateTimeReactComponent,
    InputDecimalReactComponent,
    InputDropDownReactComponent,
    // InputFileReactComponent,
    InputIntegerReactComponent,
    InputListboxReactComponent,
    InputPasswordReactComponent,
    InputSelectReactComponent,
    InputStringReactComponent,
    InputTelReactComponent,
    InputTextReactComponent,
    // InputTreeViewCardsReactComponent,
    // InputTreeViewReactComponent,
    InputItemListComponent,
    InputKeyvalueListComponent,
    InputRichTextReactComponent,
    // InputFileDropReactComponent,
    // InputFileGridReactComponent,
    InputPromptModalComponent,
    // InputNodesReactComponent,
    InputSelectableListReactComponent,
    InputRadioReactComponent,
    InputDateTimeAltReactComponent,
  ],
  providers: [provideEnvironmentNgxMask()]
})
export class InputsReactModule { }
